var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bot-badges"},[_c('span',{staticClass:"badge",class:_vm.badgeStyle,attrs:{"title":_vm.badgeText}},[_vm._v(" "+_vm._s(_vm.badgeText.length > 8 ? _vm.badgeText.substr(0, 6) + '...' : _vm.badgeText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }